// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* target file for webpack loader */
`, "",{"version":3,"sources":["webpack://./node_modules/next/font/google/target.css"],"names":[],"mappings":"AAAA,mCAAmC","sourcesContent":["/* target file for webpack loader */\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
